import api from '@/utils/axios';

export const fetchWorkflowPending = async () => {
  const response = await api.post('workflow/pending', {});
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to fetch workflow queue');
  }
  return response.data.data || { plans_pending: [], appraisals_pending: [] };
};

/**
 * @param {Record<string, unknown>} payload tab, page, page_size, sort, filters (q, object_type, status, …)
 */
export const fetchWorkflowInbox = async (payload = {}) => {
  const response = await api.post('workflow/inbox', payload);
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to load inbox');
  }
  return response.data.data;
};

export const fetchInboxSummary = async () => {
  const response = await api.post('workflow/inbox/summary', {});
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || 'Failed to load inbox summary');
  }
  return response.data.data || { pending_item_count: 0, breakdown: {} };
};
